export const getters = {
  nationalites(state){
    console.log('Getter: ', state.nationalites)
    return state.nationalites
  },
  nationalite(state){
    return state.nationalite
  }
}